import React from "react";
import { TERMS_VERSION } from "../../common/constants";
import logo from "../../assets/logo_round.png";

const PrivacyPolicy = () => {
 return (
 <div
 style={{
 backgroundColor: "#f5f7fb",
 minHeight: "100vh",
 padding: "60px 20px",
 }}
 >
 <div
 style={{
 maxWidth: "900px",
 margin: "0 auto",
 backgroundColor: "#ffffff",
 padding: "40px",
 borderRadius: "12px",
 boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
 lineHeight: "1.8",
 color: "#333",
 }}
 >
 {/* Brand Header */}
 <div
 style={{
 display: "flex",
 alignItems: "center",
 gap: "14px",
 marginBottom: "24px",
 paddingBottom: "20px",
 borderBottom: "1px solid #eee",
 }}
 >
 <img
 src={logo}
 alt="Speak Bold with KK Logo"
 style={{
 width: "56px",
 height: "56px",
 objectFit: "contain",
 borderRadius: "10px",
 backgroundColor: "#fff",
 }}
 />

 <div>
 <div
 style={{
 fontSize: "1.25rem",
 fontWeight: "700",
 color: "#111",
 lineHeight: "1.2",
 }}
 >
 Speak Bold with KK
 </div>

 <div
 style={{
 fontSize: "0.95rem",
 color: "#666",
 marginTop: "4px",
 }}
 >
 Learn confidently. Speak boldly.
 </div>
 </div>
 </div>

 {/* Header */}
 <h1
 style={{
 marginBottom: "10px",
 fontSize: "2.2rem",
 fontWeight: "700",
 color: "#111",
 }}
 >
 Privacy Policy
 </h1>

 <p style={{ color: "#666", marginBottom: "30px" }}>
 Speak Bold with KK (SpeakBold Club App) • Version {TERMS_VERSION}
 </p>

 <p>
 At <strong>Speak Bold with KK</strong>, we operate the mobile
 application <strong>SpeakBold Club</strong> and related website/services
 (accessible via speakboldwithkk.com). We are committed to protecting
 your personal information. This Privacy Policy explains how we collect,
 use, store, and protect your data when you use our mobile application,
 website, or services.
 </p>

 <p>
 By using our services, you agree to the collection and use of
 information in accordance with this policy.
 </p>

 {/* Section 1 */}
 <h2 style={sectionTitleStyle}>Information We Collect</h2>
 <ul style={listStyle}>
 <li>Name</li>
 <li>Email address</li>
 <li>Mobile/WhatsApp number (when voluntarily provided)</li>
 <li>Account-related information</li>
 <li>Usage data (app interactions, pages visited, time spent)</li>
 <li>Payment information (processed securely by Razorpay)</li>
 </ul>

 {/* Section 2 */}
 <h2 style={sectionTitleStyle}>How We Use Your Information</h2>
 <ul style={listStyle}>
 <li>To create and manage your account</li>
 <li>To provide sessions, courses, and premium content</li>
 <li>To improve our services and user experience</li>
 <li>To send updates, confirmations, and notifications via email and WhatsApp</li>
 <li>To offer new features, services, or promotions</li>
 <li>To analyze usage trends and platform performance</li>
 </ul>

 {/* Section 3 */}
 <h2 style={sectionTitleStyle}>Data Retention</h2>
 <p>
 We retain your personal data only as long as necessary to provide our
 services and comply with legal obligations. You may request deletion of
 your data at any time.
 </p>

 {/* Section 4 */}
 <h2 style={sectionTitleStyle}>Data Sharing and Disclosure</h2>
 <p>
 We do not sell your personal data. We may share your data only with
 trusted service providers or when required by law.
 </p>
 <ul style={listStyle}>
 <li>With payment processors like Razorpay</li>
 <li>To comply with legal obligations</li>
 <li>To protect platform safety and prevent misuse</li>
 <li>During business transfers (e.g., merger or acquisition)</li>
 </ul>

 {/* WhatsApp Communication */}
 <h2 style={sectionTitleStyle}>WhatsApp Communication</h2>
 <p>
 If you choose to provide your WhatsApp number, we may send you session
 reminders, schedule updates, promotional offers, and platform
 announcements via WhatsApp. WhatsApp messages are sent directly from
 Speak Bold with KK without involving any third-party messaging service.
 </p>
 <p>
 Your WhatsApp number is stored securely on our servers and is never
 shared with or sold to any third party. You can remove your WhatsApp
 number or disable WhatsApp notifications at any time from your Profile
 settings.
 </p>

 {/* Section 5 */}
 <h2 style={sectionTitleStyle}>Data Security</h2>
 <p>
 We implement industry-standard security measures to protect your
 personal information. However, no system is 100% secure, and we cannot
 guarantee absolute security.
 </p>

 {/* Section 6 */}
 <h2 style={sectionTitleStyle}>Your Rights</h2>
 <ul style={listStyle}>
 <li>Access your personal data</li>
 <li>Update or correct your data</li>
 <li>Request deletion of your data</li>
 <li>Withdraw consent where applicable</li>
 <li>Opt out of WhatsApp or email communications at any time</li>
 </ul>

 {/* Section 7 */}
 <h2 style={sectionTitleStyle}>Children’s Privacy</h2>
 <p>
 Our services are not intended for users under the age of 13. We do not
 knowingly collect personal data from children.
 </p>

 {/* Section 8 */}
 <h2 style={sectionTitleStyle}>Third-Party Services</h2>
 <p>
 Our platform may include third-party services such as payment gateways.
 These providers have their own privacy policies.
 </p>
 <p>
 Example: <strong>Razorpay</strong> (payment processing)
 </p>

 {/* Section 9 */}
 <h2 style={sectionTitleStyle}>Changes to This Policy</h2>
 <p>
 We may update this policy periodically. Continued use of our services
 indicates acceptance of the updated policy.
 </p>

 {/* Section 10 */}
 <h2 style={sectionTitleStyle}>Contact Us</h2>
 <p>
 For any questions regarding this Privacy Policy, you can contact us at:
 </p>

 <div
 style={{
 backgroundColor: "#f9fafc",
 padding: "20px",
 borderRadius: "8px",
 marginTop: "15px",
 }}
 >
 <p style={{ margin: "5px 0" }}>
 <strong>Email:</strong> support@speakboldwithkk.com
 </p>
 <p style={{ margin: "5px 0" }}>
 <strong>Location:</strong> Madhya Pradesh, India
 </p>
 </div>

 {/* Footer */}
 <div
 style={{
 marginTop: "40px",
 paddingTop: "20px",
 borderTop: "1px solid #eee",
 fontSize: "0.9rem",
 color: "#888",
 }}
 >
 Last Updated: {new Date().getFullYear()} <br />© {new Date().getFullYear()} Speak Bold with KK. All rights reserved.
 </div>
 </div>
 </div>
 );
};

const sectionTitleStyle = {
 marginTop: "35px",
 fontSize: "1.4rem",
 fontWeight: "600",
 color: "#222",
};

const listStyle = {
 paddingLeft: "20px",
 marginTop: "10px",
};

export default PrivacyPolicy;